module.exports = __webpack_public_path__ + "img/p10-1.88c89423.png";